const Menu = [
  { is_header: true, title: "Overview" },
  { path: "/dashboard", icon: "bi bi-cpu", title: "Overview" },
  { path: "/matar-dashboard", icon: "bi bi-cpu", title: "Overview" },
  {
    path: "/machine-monitoring",
    icon: "bi bi-cpu",
    title: "Machine Monitoring",
  },
  // {
  //   path: "/analytics",
  //   icon: "bi bi-pie-chart",
  //   title: "Weekly Analytics",
  // },
  {
    path: "/alarm/list",
    icon: "bi bi-exclamation-octagon",
    title: "Alarm",
  },
  {
    path: "/notification-logs",
    icon: "bi bi-bell",
    title: "Notification Logs",
  },
  // {
  //   path: "/machine/list",
  //   icon: "bi bi-boombox",
  //   title: "Machines",
  //   children: [
  //     { path: "/machine/hierarchy", title: "Machine Hierarchy" },
  //     { path: "/machine/list", title: "Machine List" },
  //   ],
  // },
  {
    path: "/machine-asset/asset-list",
    icon: "bi bi-boombox",
    title: "Monitored Assets",
    children: [
      { path: "/machine/hierarchy", title: "Machine Hierarchy" },
      { path: "/machine-asset/asset-list", title: "Machine List" },
    ],
  },
  {
    path: "/machine-asset/investment-list",
    icon: "bi bi-list-check",
    title: "Investment Profile",
  },
  {
    path: "/machine-asset/financial-strategies",
    icon: "fa fa-money-bill",
    title: "Financial Strategies",
  },
  {
    path: "/report/export",
    icon: "bi bi-file-pdf",
    title: "Reports",
    children: [
      { path: "/report/export", title: "Report Generator" },
      { path: "/report/document", title: "Documents" },
    ],
  },
  {
    path: "/documents",
    icon: "bi bi-file-pdf",
    title: "Documents",
    children: [
      { path: "/document/list", title: "Documents" },
      { path: "/document/doc-chat", title: "Chat AI" },
    ],
  },
  {
    path: "/configuration",
    icon: "bi bi-gear",
    title: "Configuration",
    children: [
      { path: "/configuration/company", title: "Company Profile" },
      { path: "/configuration/location", title: "Location" },
      { path: "/configuration/roles", title: "Roles" },
      { path: "/configuration/group", title: "Asset Group" },
      { path: "/configuration/users", title: "Users" },
      { path: "/configuration/teams", title: "Teams" },
      {
        path: "/configuration/notification-hierarchy",
        title: "Notification Hierarchy",
      },
      // { path: "/configuration/faq", title: "FAQ" },
    ],
  },
];

export default Menu;
